import { cardHeaderClasses, styled } from "@mui/material"
import { simpleWidgetCardName, simpleWidgetCardSlots } from "@tm/themes"
import { SimpleCardHeader } from "../../../muiStyled/Surfaces/simpleCard"

export const SimpleWidgetCardHeader = styled(SimpleCardHeader, {
    name: simpleWidgetCardName,
    slot: simpleWidgetCardSlots.header,
    overridesResolver: (_, styles) => styles.header,
})({
    [`>.${cardHeaderClasses.action}`]: {
        marginRight: 0,
    },
})
